import React from "react";
import { StyledCalendarDiv } from "./styles";
import CustomCalendar from "./CustomCalendar";
const CalendarPage = () => {
  return (
    <StyledCalendarDiv>
      <CustomCalendar />
    </StyledCalendarDiv>
  );
};

export default CalendarPage;
